<template>
  <div>
    <loadingSpan v-if='loading ' :loadZIndex='loadZIndex'></loadingSpan>
    <div class="baseContainter">
      <lk-affix>
      <div class="subHeader clear">
        <div class="breadcrumb">
          <lk-breadcrumb>
            <lk-breadcrumb-item v-for="item in breadcrumb" :key='item.name' :to="{name:item.name}">
              {{item.title}}
            </lk-breadcrumb-item>
          </lk-breadcrumb>
        </div>
        <div class="ctrls" v-if="showButton || this.showCtrls || isShowBtn">
          <lk-button @click="handleClear" v-if="clearText">{{clearText}}</lk-button>
          <lk-button @click="handleCancel" v-if="cancelText">{{cancelText}}</lk-button>
          <lk-button v-if="saveText" :type='submitText ?"default":"primary"' :loading='saveLoading' @click="handleSave">
            <span v-if="saveLoading">保存中...</span>
            <span v-else>{{saveText}}</span>
            </lk-button>

          <lk-button v-if="submitText" @click="handleSubmit" type='primary' :loading='submitLoading'>{{submitText}}</lk-button>

        </div>
        <div class="moreBtns"  v-if="logText || printText || otherBtnText || coldChainBtnText || logisticsBtnText || recipePassText">
          <lk-button type='primary' @click="handleSearchClick('passRecipe')" v-if="recipePassText">{{recipePassText}}</lk-button>
          <lk-button  @click="handlePrint" v-if="printText">{{printText}}</lk-button>
          <lk-button @click="handleLog" v-if="logText">{{logText}}</lk-button>
          <lk-button @click="handleClickOtherBtn" v-if="otherBtnText">{{otherBtnText}}</lk-button>
          <lk-button @click="handleSearchClick('logistics')" v-if="logisticsBtnText">{{logisticsBtnText}}</lk-button>
          <lk-button @click="handleSearchClick('coldChain')" v-if="coldChainBtnText">{{coldChainBtnText}}</lk-button>
        </div>
      </div>
        <lk-button v-if="showCancelBtn && handlePermission('cancelFinPayable')" class="cancelBtn" @click="cancelModal">取消审核</lk-button>
        <div class="info" v-if="infos">
          <div>{{idText}}:{{infos.id}}</div>
          <div>
            <span v-if="infos.goodsName">商品通用名:</span><span v-if="infos.goodsName" class="padding-span">{{infos.goodsName}}</span>
            <span>创建人:</span><span class="padding-span">{{infos.createUserName}}</span>
            <span >创建时间:</span><span class="padding-span">{{infos.createTime}}</span>
            <span >修改人:</span><span class="padding-span">{{ infos.modifiedUserName}}</span>
            <span >最后修改时间:</span><span class="padding-span">{{infos.modifiedTime}}</span>
          </div>
        </div>
        <div class="info" v-if="(idText&&!infos)||infosArr.length">
          <div v-if="idText && !infos">
            <span class="padding-span">{{idText+': '+id}}</span>
            <span class="padding-span" v-for="subInfo in subInfosArr" :key="subInfo.value">{{subInfo.name+': ' + subInfo.value}}</span>
          </div>
          <div v-if="infosArr.length">
            <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
              <span>
                {{item.name}}
              </span>
              <span>
                {{item.value}}
              </span>
            </span>
          </div>
        </div>
        <slot name="affixInfo" ></slot>
        </lk-affix>
      <div class="content">
        <slot name="content" ></slot>
      </div>
      <operate-log v-model="showLog" :logList="newRecord?newRecordlist:recordlist"/>
    </div>
  </div>
</template>
<script>
import OperateLog from '../operateLog';
import utils from '../../libs/utils';
import loadingSpan from '../LoadingSpan.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'baseFrame',
  mixins: [mapState, queryMixins],
  components: {
    OperateLog, loadingSpan,
  },
  props: {
    showCtrls: {
      type: Boolean,
      default: false,
    },
    loadZIndex: { // loadingSpan的层级是否最高
      type: Boolean,
      default: false,
    },
    isShowBtn: { // 是否展示右上角几个按钮
      type: Boolean,
      default: false,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
    infos: {
      type: Object,
      default: null,
    },
    logText: {
      type: String,
      default: '',
    },
    logData: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: '',
    },
    infosArr: {
      type: Array,
      default: () => [],
    },
    subInfosArr: {
      type: Array,
      default: () => [],
    },
    saveText: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: '',
    },
    idText: {
      type: String,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    clearText: {
      type: String,
      default: '重置',
    },
    auditText: {
      type: String,
      default: '审核',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    printText: {
      type: String,
      default: '',
    },
    newRecord: {// 是否用新方法处理修改日志
      type: Boolean,
      default: false,
    },
    otherBtnText: {
      type: String,
      default: '',
    },
    coldChainBtnText: {
      type: String,
      default: '',
    },
    logisticsBtnText: {
      type: String,
      default: '',
    },
    showCancelBtn: {
    },
    recipePassText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      btns: false,
      showLog: false,
      saveType: 'primary',
      searchType: {
        logistics: 'logisticsClick',
        coldChain: 'coldChainClick',
        passRecipe: 'passRecipeClick',
      },
    };
  },
  computed: {
    loading() {
      return this.$store.state.app.loading;
    },
    showButton() {
      const result = ['add', 'Add', 'edit', 'Edit', 'modify', 'Mangement', 'pcOrderPharmaceuticalCare', 'pharmaceuticalCare'].reduce((pre, item) => {
        return this.$route.name.includes(item) || pre;
      }, false);
      return result;
    },
    newRecordlist() {
      const result = [];
      let logItem = {};
      this.logData.forEach((item) => {
        const time = utils.formatTime(item.createTime, 'YYYY/MM/DD HH:mm');
        if (item.type === 1) {
          logItem = {
            content: `${time}由${item.createUserName + item.typeName}`,
          };
        }
        if (item.type === 2) {
          let children = [];
          if (item.logList.length) {
            children = item.logList.map(modifyItem => ({
              content: `${modifyItem.content || ''},旧值: ${modifyItem.oldValue || ''}, 新值: ${modifyItem.newValue || ''}`,
            }));
          }
          logItem = {
            content: `${time}由${item.createUserName + item.typeName}`,
            children,
          };
        }
        if (item.type === 3) {
          logItem = {
            content: `${time}由${item.createUserName}审方`,
          };
        }
        if (item.type === 4) {
          logItem = {
            content: `${time}由${item.createUserName + item.typeName}`,
          };
        }
        result.push(logItem);
      });
      return result;
    },
    recordlist() {
      const result = [];
      let logItem = {};
      this.logData.forEach((item) => {
        const logList = item.logList || item.operateList || [];
        const time = utils.formatTime(item.createTime, 'YYYY/MM/DD HH:mm');
        if (item.type === 1) {
          logItem = {
            content: `${time}由${item.createUserName}创建`,
          };
        }
        if (item.type === 2) {
          let children = [];
          if (logList.length) {
            children = logList.map(modifyItem => ({
              content: `${modifyItem.content || ''},旧值: ${modifyItem.oldValue || ''}, 新值: ${modifyItem.newValue || ''}`,
            }));
          }
          logItem = {
            content: `${time}由${item.createUserName}修改`,
            children,
          };
        }
        if (item.type === 3) {
          let children = [];
          let status = '';
          if (logList.length) {
            children = logList.map((reviewItem) => {
              const reviewTime = utils.formatTime(reviewItem.operateTime, 'YYYY/MM/DD HH:mm');
              if (reviewItem.workStatus === 1) {
                status = '通过';
              } else if (reviewItem.workStatus === 2) {
                status = '驳回';
              } else if (reviewItem.workStatus === 3) {
                status = '处理中';
              }
              return {
                content: `${reviewTime},由${reviewItem.operateUserName || ''}审批, 结果： ${status || ''}，意见： ${reviewItem.idea || ''}`,
              };
            });
          }
          logItem = {
            content: `${time || ''}由${item.createUserName || ''}审批`,
            children,
          };
        }
        if (item.type === 4) {
          logItem = {
            content: `${time}由${item.createUserName}提交审批`,
          };
        }
        result.push(logItem);
      });
      return result;
    },
    breadcrumb() {
      const breadcrumb = [{
        name: this.$route.meta.menuNav,
        title: this.$route.meta.parentTitle,
      },
      ];
      if (this.$route.meta.subTitle) {
        breadcrumb.push({
          title: this.$route.meta.subTitle,
        });
      }
      return breadcrumb;
    },
  },
  methods: {
    handleSearchClick(type) {
      this.$emit(this.searchType[type]);
    },
    handleLog() {
      this.$emit('hanldeLog');
      this.showLog = true;
    },
    handleSave() {
      this.$emit('save');
    },
    handleClear() {
      this.$emit('clear');
    },
    handleAudit() {
      this.$emit('audit');
    },
    handleCancel() {
      this.$store.commit('setLeaveModal', false);
      if (this.$route.name === 'supplierGeneralEdit') {
        this.$router.push({ name: 'supplierGeneral' });
      } else if (this.$route.name === 'supplierStoreEdit') {
        this.$router.push({ name: 'supplierStore' });
      } else if (this.$route.name === 'supplierStoreEdit') {
        this.$router.push({ name: 'supplierStore' });
      } else if (this.$route.name === 'goodsBaseEdit') {
        this.$router.push({ name: 'goodsBaseList' });
      } else if (this.$route.name === 'recipsSalesAdd' || this.$route.name === 'recipeSalesEdit') {
        this.$router.push({ name: 'recipeSalesRecord' });
      } else {
        this.$router.go(-1);
      }
    },
    handlePrint() {
      this.$emit('print');
    },
    handleSubmit() {
      this.$emit('submit');
    },
    handleClickOtherBtn() {
      this.$emit('otherClick');
    },
    cancelModal() {
      this.$emit('showModal');
    },
  },
  mounted() {

  },
  created() {
    if (this.$route.name.includes('Add')// 根据routerName判定统一router name
      || this.$route.name.includes('Edit')) {
      this.$emit('setAble', true);
      this.btns = true;
    } else {
      this.btns = false;
      this.$emit('setAble', false);
    }
  },
};
</script>
<style lang="less" scoped>
.baseContainter{
  position:relative;
  min-height:calc(~'100vh - 85px');// 100vh;
  .subHeader{
    padding-left: 24px;
    padding-right: 32px;
    padding-top: 8px;
    padding-bottom: 8px;
    background: #fff;
    line-height: 32px;
    .ctrls{
      float: right;
    }
    .ctrls>*{
      margin-left: 16px
    }
    .breadcrumb{
      float: left;
    }
  }
  .content{
    padding: 16px;
    padding-top: 12px;
  }
  .info{
    background: #fff;
    padding:0  32px;
    padding-bottom: 20px;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
  }
  .info div:first-child{
    color: rgba(0,0,0,0.75);
  }
}
.padding-span{
  padding-right:15px;
}
.moreBtns{
  float: right
}
.moreBtns>*{
  margin-left: 16px
}
.record{
  font-size: 14px;
  padding: 0 10px;
  line-height: 2
}
.records{
  max-height: 60vh;
  overflow: auto
}
.cancelBtn{
  position: absolute;
  right: 100px;
  top: 30px;
}
</style>
